import React from 'react'
import Box from '@mui/material/Box'

const TableGridDiv = ({children, className}) => {
    return (
        <Box className={className} sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            gridTemplateRows: 'repeat(12, 1fr)',
            height: '550px',
            overflow: 'auto',
            '& .gridTableHeader': {
                margin: 'auto auto auto 0',
                paddingLeft: '16px'
            },
            '& .tableData': {
                margin: 'auto auto auto 0',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                paddingLeft: '20px'
            }
        }}>
            {children}
        </Box>
    )
}

export default  TableGridDiv
